

























































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  InstantTransferFailureDetailModel,
  transactionTypeMap,
  failureReasonMap,
  accountSubStatusMap,
  IntraBankTransactionMessageTypes
} from "@/admin/types";
import {
  bankCustodianMap,
  accountStatusMap,
  EmploymentStatus,
  employmentStatusMap
} from "@/shared/types";
import { formatDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useInstantTransactionFailureStore } from "@/admin/store/instantTransactionFailure";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class AdminUtilityInstantTransferDetail extends Vue {
  formatCurrency = formatCurrency;
  formatDateString = formatDateString;
  accountStatusMap = accountStatusMap;
  accountSubStatusMap = accountSubStatusMap;
  transactionTypeMap = transactionTypeMap;
  failureReasonMap = failureReasonMap;
  bankCustodianMap = bankCustodianMap;
  employmentStatusMap = employmentStatusMap;
  notifierStore = useNotifierStore();
  instantTransactionFailureStore = useInstantTransactionFailureStore();

  @Prop() instantTransferFailureDetail: InstantTransferFailureDetailModel;

  isArchived = false;
  isSaving = false;

  @Watch("instantTransferFailureDetail", { deep: true })
  onDetailChanged (detail: InstantTransferFailureDetailModel) {
    this.isArchived = detail.isArchived;
    if (detail.employerName) {
      this.instantTransactionFailureStore.getEmploymentStatus(detail.cognitoUsername);
    }
  }

  get isSubmitEnabled () {
    return false;
  }

  retryFields = [
    {
      key: "dateCompleted",
      label: "Date Completed"
    },
    {
      key: "custodianTransactionId",
      label: "Bank Transaction ID"
    },
    {
      key: "transactionStatus",
      label: "Transaction Status"
    }
  ];

  get allRetries () {
    return [{ status: "retry data", dateCreated: "DATE" }];
  }

  get hasCurrentErrorMessage () {
    return !!this.instantTransferFailureDetail.custodianErrorResponse;
  }

  onCancelClick () {
    this.$router.go(-1);
  }

  onResolveClick () {
    this.instantTransactionFailureStore.resolveById(this.instantTransferFailureDetail.transactionId).then(v => {
      this.notifierStore.setSuccess("Instant Transaction Failure item has been archived.");
    });
  }

  onFormSubmit () {
    if (!this.isSaving) {
      this.isSaving = true;
      this.instantTransactionFailureStore.retryById(this.instantTransferFailureDetail.transactionId)
        .then(v => {
          this.notifierStore.setSuccess("Instant Transaction Retry has been initiated.");
        }).finally(() => {
          this.isSaving = false;
        });
    }
  }
  get isLoaded () {
    return this.instantTransactionFailureStore.isDetailLoaded;
  }
  get canRetry () {
    return this.instantTransactionFailureStore.isDetailLoaded
      && this.instantTransactionFailureStore.detailItem.isRetriable;
  }
}
